"use client";

import { useState, useEffect } from "react";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    // Ensure window is defined (for SSR/server components)
    if (typeof window === "undefined") {
      return;
    }

    const mediaQueryList = window.matchMedia(query);

    const documentChangeHandler = () => setMatches(mediaQueryList.matches);

    // Set the initial state
    documentChangeHandler();

    // Listen for changes
    try {
      // Newer browsers
      mediaQueryList.addEventListener("change", documentChangeHandler);
    } catch (e) {
      // Older browsers (Safari < 14)
      mediaQueryList.addListener(documentChangeHandler);
    }

    // Cleanup function
    return () => {
      try {
        mediaQueryList.removeEventListener("change", documentChangeHandler);
      } catch (e) {
        mediaQueryList.removeListener(documentChangeHandler);
      }
    };
  }, [query]); // Re-run effect if query changes

  return matches;
}
